export const HISTORY_CARD_LABELS = {
    vacations: 'Férias',
    timeline: 'Linha do Tempo',
    acquisitionPeriod: 'Período aquisitivo',
    manualEntry: 'Lançamento manual · sem solicitação no sistema',
    withSell: 'Com abono',
    loading: 'Carregando...',
    empty: 'Nenhum resultado encontrado.',
} as const;

export const HISTORY_CARD_CLASSES = {
    container: 'rounded-lg border border-gray-200 bg-white p-4 transition-colors font-montserrat',
    containerClickable: 'cursor-pointer hover:border-primary-300 hover:bg-primary-50',
    row: 'grid grid-cols-[1fr_auto] items-start gap-x-3 gap-y-4 md:grid-cols-[18rem_1fr_auto] md:gap-x-6',
    identity: 'flex items-start gap-3 min-w-0',
    segmentsColumn: 'col-span-2 order-last min-w-0 md:col-span-1 md:order-none',
    statusColumn: 'justify-self-end md:order-last',
    name: 'break-words font-semibold text-gray-900',
    email: 'truncate text-sm text-gray-600',
    status: 'inline-flex shrink-0 items-center rounded-full px-3 py-1 text-xs font-medium',
    divider: 'border-t border-gray-100 pt-3',
    dividerVertical: 'md:border-t-0 md:border-l md:pl-6 md:pt-0',
    label: 'text-xs text-gray-500 uppercase tracking-wide mb-2',
    segmentsList: 'space-y-2',
    segment: 'text-sm text-gray-900',
    segmentRejected: 'line-through text-gray-500',
    segmentLabel: 'font-medium',
    segmentDays: 'text-gray-600',
    rejectedBadge: 'ml-1 text-xs text-red-600 font-medium',
    sellInfo: 'text-xs text-primary-600 font-medium mt-2',
    acquisitionInfo: 'text-xs text-gray-600 mt-3 pt-2 border-t border-gray-100',
    acquisitionLabel: 'text-gray-500 font-medium',
    timelineButton: 'inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors -ml-3',
    chevronIcon: 'h-4 w-4 transition-transform',
} as const;
